import React from 'react'

const FloatingLabelInput = ({
  label,
  value,
  onChange,
  type = 'text',
  required = false,
  className = '',
  style = {},
  component: Component = 'input',
  isTextarea = false,
  onFocus,
  ...props
}) => {
  const InputComponent = isTextarea ? 'textarea' : Component

  return (
    <div className='position-relative' style={{ ...style }}>
      <small
        className='position-absolute text-muted'
        style={{
          fontSize: '0.7rem',
          top: '2px',
          left: '8px',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        {label}
      </small>
      <InputComponent
        type={!isTextarea ? type : undefined}
        value={value}
        onChange={e => {
          onChange(e)
          if (isTextarea && e.target) {
            e.target.style.height = 'auto'
            e.target.style.height = `${e.target.scrollHeight}px`
          }
        }}
        onFocus={e => {
          if (isTextarea && e.target) {
            e.target.style.height = 'auto'
            e.target.style.height = `${e.target.scrollHeight}px`
          }
          onFocus?.(e)
        }}
        required={required}
        className={`form-control form-control-sm ${className}`}
        style={{
          paddingTop: '18px',
          paddingBottom: '4px',
          height: isTextarea ? 'auto' : undefined,
          resize: isTextarea ? 'none' : undefined,
          overflow: isTextarea ? 'hidden' : undefined,
          ...style,
        }}
        {...props}
      />
    </div>
  )
}

export default FloatingLabelInput
